import React from 'react';
import AssetForm from '../../components/AssetForm/AssetForm';


function CreatePortfolio() {

  return (<AssetForm />);
}

export default CreatePortfolio;
